import AccountModes from './account-modes.constant';
import ProviderAccountViewModelService from './provider-account-view-model.service';

var DATE_FORMAT = 'MMM Do @ h:mma';

angular.module('accountViewServices', ['angularMoment'])
  .constant('AccountModes', AccountModes)
  .factory('formatDate',
           (moment) => (date) => date ? moment(date).format(DATE_FORMAT) : 'None')
  .factory('formatDateAsRelative',
           (moment) => (date) => date ? moment(date).fromNow() : 'None')
  .service('ProviderAccountViewModelService', ProviderAccountViewModelService);
